#import "../fragments/stageset-fragment.graphql"
#import "../fragments/entity-attribute-enum-fragment.graphql"

mutation UpdateCustomField($input: CustomFieldUpdateInput!) {
    updateCustomField(input: $input) {
        customField {
            id
            attribute {
                name
            }
            stagesets {
                ...StagesetFragment
            }
            ... on EntityAttributeEnum {
                ...EntityAttributeEnumFragment
            }
        }
    }
}
